import { createSelector } from '@reduxjs/toolkit';
import { dealTypeFromJsonQuery, FDealType } from '../../../../packages/JsonQuery';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';

const DEAL_TYPES: Partial<Record<FDealType, string>> = {
  [FDealType.Sale]: 'Купить',
  [FDealType.RentLongterm]: 'Снять',
  [FDealType.RentDaily]: 'Посуточно',
};

export const selectDealTypeFilter = createSelector(selectJsonQuery, jsonQuery => {
  const value = dealTypeFromJsonQuery(jsonQuery);
  const label = DEAL_TYPES[value] || '';

  return { label, value };
});
